/**
 * O HISTÓRICO DE ATUALIZAÇÕES — a lista de todas as versões e o que mudou em
 * cada uma (14/08, Lucas: "o aviso mostra só o resumo da última; quem quiser
 * mais clica em ver histórico").
 *
 * Abre por cima da tela, de qualquer módulo, sem tirar a pessoa de onde ela
 * estava — é consulta, não navegação.
 */

import { escapar } from './formato.js';
import { VERSOES, VERSAO_ATUAL, type Versao } from '../versoes.js';

function dataBr(iso: string): string {
  return `${iso.slice(8, 10)}/${iso.slice(5, 7)}/${iso.slice(0, 4)}`;
}

function bloco(v: Versao, primeira: boolean): string {
  return `
    <article class="hv-versao${primeira ? ' atual' : ''}">
      <header>
        <b>${escapar(v.versao)}</b>
        <span class="hv-data">${dataBr(v.data)}</span>
      </header>
      <ul>${v.itens.map((i) => `<li>${escapar(i)}</li>`).join('')}</ul>
    </article>`;
}

export function abrirHistoricoDeVersoes(): void {
  document.querySelector('.hv-pagina')?.remove();
  const pagina = document.createElement('div');
  pagina.className = 'hv-pagina';
  pagina.innerHTML = `
    <div class="hv-cartao">
      <header class="hv-topo">
        <div>
          <h2>🗒️ Histórico de atualizações</h2>
          <p class="dica">Você está usando a <b>${escapar(VERSAO_ATUAL.versao)}</b>.
            O número do meio muda quando o sistema é atualizado para todo mundo;
            o do fim, a cada versão testada antes disso.</p>
        </div>
        <button class="btn btn-claro" id="hv-fechar" type="button">Fechar</button>
      </header>
      <div class="hv-lista">${VERSOES.map((v, i) => bloco(v, i === 0)).join('')}</div>
    </div>`;
  document.body.appendChild(pagina);

  const fechar = () => pagina.remove();
  pagina.querySelector('#hv-fechar')!.addEventListener('click', fechar);
  // Clique fora e Esc fecham — quem abriu por curiosidade não fica preso.
  pagina.addEventListener('click', (e) => {
    if (e.target === pagina) fechar();
  });
  document.addEventListener(
    'keydown',
    (e) => {
      if (e.key === 'Escape') fechar();
    },
    { once: true },
  );
}

/** O link que abre o histórico — usado no aviso de novidades e no hub. */
export function instalarLinkDeHistorico(dentro: ParentNode, seletor = '[data-ver-historico]'): void {
  dentro.querySelectorAll<HTMLElement>(seletor).forEach((el) => {
    el.addEventListener('click', (e) => {
      e.preventDefault();
      abrirHistoricoDeVersoes();
    });
  });
}
